export const ORDER_TYPE = ["pickup", "delivery"] as const;
export type OrderType = (typeof ORDER_TYPE)[number];

export const ORDER_TYPE_OBJ = ORDER_TYPE.reduce((acc, type) => {
    acc[type] = type;
    return acc;
}, {} as Record<OrderType, OrderType>);

